import { usePage } from '@inertiajs/react';

/**
 * Detects if the current page is a version history view.
 * Matches page and site version history routes scoped to a preview page.
 */
export function useIsVersionHistory(): boolean {
  const { url } = usePage();
  const versionHistoryPattern = /\/pages\/[^/]+\/(page|site)-versions(\/|$|\?)/;
  return versionHistoryPattern.test(url);
}
